import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6 0a.429.429 0 0 0-.429.429v4.928a.214.214 0 0 1-.214.214H.429A.429.429 0 0 0 0 6a6 6 0 1 0 6-6Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m3.184 4.245-1.06-1.061a.751.751 0 1 1 1.023-1.1l.037.037 1.061 1.06a.75.75 0 0 1-1.061 1.061Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }